<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit">
        הסטוריית המחלה (אינדיקציה לניתוח ומחלה נוכחית)
        <span class="only-doc-fill flex">
          <img src="/assets/img/svg/doctor-fill.svg" />
          למילוי ע״י הרופא
        </span>
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>
    <div v-show="isOpen" class="book_surgery_open toggleInner">
      <div class="inner_group bg--white desk-no-pad">
        <div class="add_new_row flex desk-no-pad desk-w-100">
          <div class="add_new_row_col1 w-100">
            פרט מתי התחילו הסימפטומים, מתי אובחן, מה השיקול הרפואי להחלטה על
            ניתוח זה, האם המחלה היא עקב גיל, עקב טראומה, עקב ניתוח קודם שכשל
          </div>
          <div class="input_area_opcity textarea-big only-doc-mark">
            <div class="only-doc-mark-in">למילוי ע״י הרופא</div>
            <textarea
              v-model="treatmentHistory"
              placeholder="פירוט..."
              autocomplete="off"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

/**
 * TreatmentHistory Component
 * Handles the disease history section (indication for surgery and current illness)
 * For doctor's use only
 */
export default {
  name: "TreatmentHistory",
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      isEditMode: state => state.isEditMode
    }),
    treatmentHistory: {
      get() {
        return this.surgery.treatment_history || "";
      },
      set(value) {
        this.SET_SURGERY({ treatment_history: value });
      }
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY"])
  },
  mounted() {
    // Open section if treatment_history has content in edit mode
    if (this.isEditMode && this.surgery.treatment_history) {
      this.isOpen = true;
    }
  }
};
</script>
